import type { FC, ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { UseAuth } from "src/auth/AuthContext";
import { validateRouteRole } from "src/helpers/mixins";
import Layout from "src/Layouts/Main";
import LayoutCashier from "src/Layouts/CashierLayout";
import LayoutAdmin from "src/Layouts/Admin";
interface GuardProps {
  children: ReactNode;
}

const ProtectGuard: FC<GuardProps> = ({ children }) => {
  const { isAuthenticated, user } = UseAuth();
  const location = useLocation();
  const role = user?.role || "user";

  if (!isAuthenticated) {
    return <Navigate to="/inicio" />;
  }

  const enableRoutes = validateRouteRole(role);
  const { pathname } = location;
  //if( !enableRoutes.includes('*') && !enableRoutes.includes(pathname)){
  if (
    !enableRoutes.includes("*") &&
    !enableRoutes.some((r) => pathname.includes(r))
  ) {
    //return <Navigate to="/inicio" />;
  }
  switch (user?.role) {
    case "user":
      return (
        <Layout>
          <>{children}</>
        </Layout>
      );
    case "cashier":
      return (
        <LayoutCashier>
          <>{children}</>
        </LayoutCashier>
      );
    case "admin":
      return <LayoutAdmin><>{children}</></LayoutAdmin>;
    default:
      return (
        <Layout>
          <>{children}</>
        </Layout>
      );
  }
};

ProtectGuard.propTypes = {
  children: PropTypes.node,
};

export default ProtectGuard;
